// extracted by mini-css-extract-plugin
export default {"container":"ElementPage_container__Y-2a0","inner":"ElementPage_inner__s-zZk","title":"ElementPage_title__Sjhlf","image":"ElementPage_image__Zi8WO","text":"ElementPage_text__2E633"};